import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import MainService from "../../common/MainService";
import { useCallback } from "react";

// Define the container style for the Google Map (full screen)
const containerStyle = {
  width: "100vw", // Full width of the viewport
  height: "100vh", // Full height of the viewport
};

// Set the initial center position for the map (default coordinates)
const center = {
  lat: 28.6448, // Latitude for the center
  lng: 77.216721, // Longitude for the center
};

function StoreLocator() {
  // State to store the list of users of type "Retailer"
  const [users, setUsers] = useState([]);
  
  // State to store the location markers for all users (stores)
  const [locationMarker, setLocationMarker] = useState([]);

  // Function to fetch all users of the "Retailer" user type
  const getAlluserType = () => {
    MainService.getAllUserofUserType("Retailer").then((res) => {
      const allusers = res.users.map((e) => e.username); // Extract usernames of retailers
      setUsers(allusers); // Update the users state with retailer usernames
    });
  };

  // Function to fetch the locations of all users (stores)
  const getStoreLocation = useCallback(() => {
    if (!Array.isArray(users) || users.length === 0) {
      return []; // No users, return an empty array
    }
    // Create an array of promises to fetch location data for each user (store)
    const allLocationPromises = users.map((username) =>
      MainService.locationProvider(username, "Store").then((res) => res)
    );
    return allLocationPromises; // Return the array of promises
  }, [users]); // Dependency on 'users' to re-fetch locations when users change

  // Fetch users when the component mounts
  useEffect(() => {
    getAlluserType();
  }, []); // Empty dependency array ensures this runs only once after the component mounts

  // Fetch locations when users are available (after the users state is updated)
  useEffect(() => {
    if (users.length > 0) {
      Promise.all(getStoreLocation()) // Wait for all location data to be fetched
        .then((res) => {
          // Flatten the array of location data (if nested) and update the location markers state
          const locations = res.flatMap((locationData) => locationData.sites);
          setLocationMarker(locations); // Set the fetched locations as markers
        })
        .catch((err) => {
          console.error("Error occurred:", err); // Log any errors
        });
    }
  }, [users, getStoreLocation]); // Dependency on 'users' to trigger location fetching whenever users change

  // Load the Google Maps API using the useJsApiLoader hook
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script", // Script ID for the Google Maps API
    googleMapsApiKey: "AIzaSyA08TJWvLGvDD4cXLo-231gioXgaugKUw0", // Google Maps API Key
  });

  // Render the Google Map once it's loaded
  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
      {/* Render markers for each store location */}
      {locationMarker
        .flat() // Flatten any nested array of locations into a single array of marker objects
        .map((marker, index) => (
          <Marker
            key={index} // Key for each marker (optimizes rendering)
            name={marker.sitename} // Name of the site (store)
            position={{
              lat: parseFloat(marker.latitude), // Convert latitude to a floating point number
              lng: parseFloat(marker.longitude), // Convert longitude to a floating point number
            }}
            title={marker.sitename} // Tooltip text for the marker (store name)
          />
        ))}
    </GoogleMap>
  ) : (
    // Return an empty fragment if the map isn't loaded yet
    <></>
  );
}

// Export the component wrapped in React.memo to optimize re-renders (prevents unnecessary re-renders)
export default React.memo(StoreLocator);
